import { render } from "./LinkPreviewFileSize.vue?vue&type=template&id=70eaceb8&ts=true"
import script from "./LinkPreviewFileSize.vue?vue&type=script&lang=ts"
export * from "./LinkPreviewFileSize.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/LinkPreviewFileSize.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70eaceb8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70eaceb8', __exports__)) {
    api.reload('70eaceb8', __exports__)
  }
  
  module.hot.accept("./LinkPreviewFileSize.vue?vue&type=template&id=70eaceb8&ts=true", () => {
    api.rerender('70eaceb8', render)
  })

}


export default __exports__